import React from 'react';
import { PrismLight as SyntaxHighlighter } from 'react-syntax-highlighter';
import python from 'react-syntax-highlighter/dist/esm/languages/prism/python';
import javascript from 'react-syntax-highlighter/dist/esm/languages/prism/javascript';
import typescript from 'react-syntax-highlighter/dist/esm/languages/prism/typescript';
import { vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism';

SyntaxHighlighter.registerLanguage('python', python);
SyntaxHighlighter.registerLanguage('javascript', javascript);
SyntaxHighlighter.registerLanguage('typescript', typescript);

// Safe syntax highlighting using React elements (no dangerouslySetInnerHTML)
function CodeHighlight({ code, language, className = '' }) {
  const lang = ['python', 'javascript', 'typescript'].includes(language) ? language : 'python';
  return (
    <SyntaxHighlighter
      language={lang}
      style={vscDarkPlus}
      className={className}
      customStyle={{
        margin: 0,
        padding: '12px',
        background: 'transparent',
        fontSize: '14px',
        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
      }}
      codeTagProps={{ style: { fontFamily: 'inherit' } }}
      data-testid="code-highlight"
    >
      {code || ''}
    </SyntaxHighlighter>
  );
}

export default CodeHighlight;
